import useFacebookAuth from 'Pages/facebookManament/hooks/useFacebookAuth'
import {FacebookLayoutGeneral} from 'Pages/facebookManament/layouts/general'
import FacebookService from 'Pages/facebookManament/services'
import {useEffect} from 'react'
import {useReducer} from 'react'
import {PageFacebookLogin} from '../login'
import {FacebookMessageConfirmOrderWrapper} from './components/wrapper'
import {FacebookMessageConfirmOrderProvider} from './provider'
import {facebookMessageConfirmOrderInitialState} from './provider/_initstate'
import {FacebookMessageConfirmOrderReducer} from './provider/_reducer'
import {useTranslation} from "react-i18next";
import {EditContent} from "./components/content";
import {Button} from "../../../../common/button";
import useFacebookMessageConfirmOrder from "./hooks/useFacebookMessageConfirmOrder";
import {useParams} from "react-router-dom";

export const PageFacebookMessageConfirmOrderEdit = () => {
    const [state, dispatch] = useReducer(
        FacebookMessageConfirmOrderReducer,
        facebookMessageConfirmOrderInitialState,
    )

    return (
        <FacebookMessageConfirmOrderProvider value={{state, dispatch}}>
            <PageContainer />
        </FacebookMessageConfirmOrderProvider>
    )
}

const PageContainer = () => {
    const params = useParams();
    const {t} = useTranslation()
    const {facebookAuth, logout, getUser, setAuthData} = useFacebookAuth()
    const {auth} = facebookAuth
    const {methods}= useFacebookMessageConfirmOrder()
    useEffect(() => {
        FacebookService.initFacebookSdk({
            getAuthData: data => setAuthData(data),
        })
    }, [])

    useEffect(() => {
        document.title = "Chỉnh sửa tin nhắn xác nhận đơn hàng"
        if (auth.userId) getUser()
    }, [auth.userId])

    if (auth.userId)
        return (
            <FacebookLayoutGeneral
                title={t("facebookManament_configuration_setup")}
                subTitle={t('editConfirmMessage')}
                isUl={true}
                breadcrumb={[{id: 1, name: t('back'), url: '/facebook/message-confirm-order', isBack: true}]}
                authData={facebookAuth}
                logout={logout}
                actions={[

                    <Button size={'md-'} appearance="ghost" href="/facebook/message-confirm-order" style={{minWidth: 74}}>
                        {t('cancel')}
                    </Button>,
                    <Button
                        size={'md-'}
                        style={{minWidth: 110, marginLeft: 12}}
                        onClick={()=>methods.onSubmit(params?.pageId)}
                    >
                        {t('save')}
                    </Button>
                ]}
            >
                <EditContent/>
            </FacebookLayoutGeneral>
        )

    return <PageFacebookLogin connect={setAuthData} />
}

